<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h3>Search Bookings</h3>
    </v-flex>
    <v-layout pt-2 class="search-fields" column>
      <form v-on:keyup.enter="search">
        <v-select
          v-model="query.state"
          :items="states"
          item-value="value"
          item-text="name"
          label="State"
          hide-details
        ></v-select>
        <v-text-field hide-details v-model="query.name" label="Customer Name"></v-text-field>
        <v-text-field hide-details v-model="query.number" label="Customer Number"></v-text-field>
        <v-text-field hide-details v-model="query.pickup" label="Pickup"></v-text-field>
        <!-- <v-text-field v-model="query.destination" label="Destination"></v-text-field> -->
        <v-flex pt-1>
          <v-layout row>
            <BookingDateInput
              @input="fromChanged"
              :content="query.after"
              label="From Date"
              :old="true"
            ></BookingDateInput>
            <v-icon @click="query.after = ''" style="padding-top: 14px;">clear</v-icon>
          </v-layout>
        </v-flex>
        <v-flex pt-1>
          <v-layout row>
            <BookingDateInput
              @input="toChanged"
              :content="query.before"
              label="To Date"
              :old="true"
            ></BookingDateInput>
            <v-icon @click="query.before = ''" style="padding-top: 14px;">clear</v-icon>
          </v-layout>
        </v-flex>
        <v-select
          v-model="query.paymentType"
          :items="paymentTypes"
          hide-details
          item-value="value"
          item-text="name"
          label="Payment Type"
        ></v-select>
        <v-select
          v-model="query.bookingMethod"
          hide-details
          :items="bookingTypes"
          item-value="value"
          item-text="name"
          label="Booking Type"
        ></v-select>
        <v-text-field hide-details v-model="query.refNum" label="Reference"></v-text-field>
        <v-text-field hide-details v-model="query.bookingID" label="Booking ID"></v-text-field>
        <v-checkbox v-model="query.hideRepeatTrips" color="primary" label="Hide Repeat Trips" />
      </form>
    </v-layout>
    <v-flex>
      <v-row>
        <v-flex pa-1 shrink>
          <v-btn small @click="search" color="blue" dark class="text-none">Search</v-btn>
        </v-flex>
        <v-flex pa-1 shrink>
          <v-btn small style="max-width: 80px;" @click="clear" class="text-none">Clear</v-btn>
        </v-flex>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import BookingDateInput from "@/components/widget/input/BookingDateInput.vue";

import moment from "moment";

export default {
  name: "booking_search_box",
  props: {
    query: Object
  },
  data: function() {
    return {
      states: [
        {
          id: 0,
          value: "all",
          name: "All"
        },
        {
          id: 1,
          value: "booked",
          name: "Booked"
        },
        {
          id: 2,
          value: "accepted",
          name: "Active"
        },
        {
          id: 3,
          value: "completed",
          name: "Completed"
        },
        {
          id: 4,
          value: "cancelled",
          name: "Cancelled"
        }
      ],
      paymentTypes: [
        {
          id: 0,
          value: "all",
          name: "All"
        },
        {
          id: 1,
          value: "cash",
          name: "Cash"
        },
        {
          id: 2,
          value: "card",
          name: "Card"
        },
        {
          id: 3,
          value: "card_in_cab",
          name: "Card in Cab"
        },
        {
          id: 4,
          value: "account",
          name: "Account"
        }
      ],
      bookingTypes: [
        {
          id: 1,
          value: "all",
          name: "All"
        },
        {
          id: 2,
          value: "app",
          name: "App"
        },
        {
          id: 3,
          value: "website",
          name: "Website"
        },
        {
          id: 4,
          value: "phone",
          name: "Phone"
        },
        {
          id: 5,
          value: "third_party",
          name: "Third Party"
        },
        {
          id: 6,
          value: "flag_down",
          name: "Flag Down"
        },
        {
          id: 7,
          value: "repeat",
          name: "Repeat Trip"
        }
      ]
    };
  },
  methods: {
    fromChanged: function(d) {
      this.query.after = d;
    },
    toChanged: function(d) {
      this.query.before = d;
    },
    search: function() {
      this.$emit("search");
    },
    clear: function() {
      this.$emit("clear");
    }
  },
  components: {
    BookingDateInput
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}
</style>
